// =========================================================================================@@
// Last Updated Date: Mar 25, 2022
// Last Updated By: Ajay
// Status Level: 1
// ===========================================================================================

import { useMutation } from '@apollo/client'
import { unapplyUserAction as unapplyUserActionGql }
   from 'src/core/graphql/mutations/unapplyUserAction.gql'

const useUnapplyUserAction = (mutationHookOptions) => {
   const [unapplyUserAction, { called, client, data, error, loading }] =
      useMutation(unapplyUserActionGql, mutationHookOptions)

   const wrappedMutationFn = (variables, mutationFnOptions) => unapplyUserAction({
      variables,
      ...mutationFnOptions
   })

   return {
      unapplyUserAction: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useUnapplyUserAction
